"use client";

// lib/motion — innernet's motion module. One import surface for spring-driven,
// reduced-motion-aware animation tuned to the house feel (soft, drift,
// settle-in; never bouncy).
//
//   import { motion, AnimatePresence, useSpringValue, springHover, SPRINGS }
//     from "@/lib/motion";  // (or a relative path)
//
// What's here:
//   • SPRINGS / spring / springTransition / INSTANT  — the spring vocabulary
//     (gentle · drift · settle · snappy), aligned with the CSS easing language.
//   • useSpringValue                                  — weighted, inertial scalar
//     for mapping a raw scroll/pointer signal to a settling value (callback-style,
//     reduced-motion → instant). Powers the scroll→organism-age spring.
//   • springHover (lift + press) / springEntrance / springStagger / staggerChild
//     and the useSpring* hook wrappers — reduced-motion-aware prop/variant
//     factories for hover, press, panel and list entrances.
//   • Curated framer-motion re-exports — so callers import motion primitives from
//     here and inherit the conventions instead of reaching into framer-motion.

export { SPRINGS, spring, springTransition, INSTANT } from "./springs";
export type { SpringName } from "./springs";

export { DUR, EASE, STAGGER, DELAY_CHILDREN } from "./tokens";

export { useSpringValue } from "./useSpringValue";
export type { SpringValueOptions, SpringValueHandle } from "./useSpringValue";

export {
  springHover,
  springEntrance,
  springStagger,
  staggerChild,
  useSpringHover,
  useSpringEntrance,
  useHoverFeel,
} from "./presets";
export type { HoverFeel } from "./presets";

// Curated framer-motion bits. Re-export the primitives the app actually needs,
// so there's a single import surface and one place to swap implementations.
export {
  motion,
  AnimatePresence,
  LayoutGroup,
  useReducedMotion,
  useInView,
  useMotionValue,
  useSpring,
  useScroll,
  useTransform,
  useMotionValueEvent,
} from "framer-motion";
export type { MotionValue, SpringOptions, Transition, Variants } from "framer-motion";
